'use client';

import { c as _c } from "react/compiler-runtime";
import HeaderButtons from '@components/header-buttons/HeaderButtons';
import { useMatchedRoute } from '@components/header-buttons/hooks/useMatchedRoute';
import { handleChangeFormName, handleOpenModelForm } from '@lib/store/slices/ComponentsSlice';
import { CONTACTS } from '@lib/tools/helpers/constants';
import Link from 'next/link';
import { useParams, usePathname } from 'next/navigation';
import { useLayoutEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import style from './HeaderBar.module.scss';
const HeaderBar = t0 => {
  const $ = _c(27);
  const {
    headerColorScheme
  } = t0;
  const dispatch = useDispatch();
  const {
    houseId,
    apartmentId,
    floorId
  } = useParams();
  const pathname = usePathname();
  const match = useMatchedRoute();
  const [headBarOrderStyle, setHeadBarOrderStyle] = useState(`${style.headerBar__order}`);
  let t1;
  if ($[0] !== apartmentId || $[1] !== floorId || $[2] !== houseId || $[3] !== pathname) {
    t1 = houseId && !apartmentId || floorId && !apartmentId || pathname.includes("visual") && !apartmentId;
    $[0] = apartmentId;
    $[1] = floorId;
    $[2] = houseId;
    $[3] = pathname;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const visualPath = t1;
  let t2;
  if ($[5] !== headerColorScheme || $[6] !== visualPath) {
    t2 = () => {
      if (headerColorScheme === "" || headerColorScheme === "blackOnTransparent" || headerColorScheme === "blackOnTransparentTwo" || headerColorScheme === "blackOnTransparentThree") {
        if (visualPath) {
          setHeadBarOrderStyle(` ${style.headerBar__order} ${style.headerBarWhite__order} ${style.headerBarWhite__text}`);
        } else {
          setHeadBarOrderStyle(` ${style.headerBar__order} ${style.headerBarWhite__order}`);
        }
      } else {
        setHeadBarOrderStyle(`${style.headerBar__order}`);
      }
    };
    $[5] = headerColorScheme;
    $[6] = visualPath;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== headerColorScheme || $[9] !== pathname) {
    t3 = [headerColorScheme, pathname];
    $[8] = headerColorScheme;
    $[9] = pathname;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useLayoutEffect(t2, t3);
  let t4;
  if ($[11] !== headBarOrderStyle) {
    t4 = <Link suppressHydrationWarning={true} className={headBarOrderStyle} href={"tel:" + CONTACTS.PHONE}>{CONTACTS.PHONE}</Link>;
    $[11] = headBarOrderStyle;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== dispatch) {
    t5 = () => {
      dispatch(handleOpenModelForm(true));
      dispatch(handleChangeFormName("callbackForm"));
    };
    $[13] = dispatch;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== headBarOrderStyle) {
    t6 = <p className={headBarOrderStyle}>Заказать звонок</p>;
    $[15] = headBarOrderStyle;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div onClick={t5} role="button" tabIndex="0" data-testid="headerFormOpen">{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const t8 = match !== null;
  let t9;
  if ($[20] !== headerColorScheme || $[21] !== t8) {
    t9 = <HeaderButtons headerColorScheme={headerColorScheme} visual={t8} />;
    $[20] = headerColorScheme;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t4 || $[24] !== t7 || $[25] !== t9) {
    t10 = <div className={style.headerBar}>{t4}{t7}{t9}</div>;
    $[23] = t4;
    $[24] = t7;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};
export default HeaderBar;